import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MDInput
import MDInputRoot from "components/MDInput/MDInputRoot";
import MDTypography from "components/MDTypography";
import { TextField } from "@mui/material";

// const MDInput = forwardRef(({ error, success, disabled, ...rest }, ref) => (
//   <>
//     <MDTypography style={{ fontSize: "16px" }} color="dark">
//       {rest.placeholder} <span style={{ color: "red" }}>{rest.required ? "*" : ""}</span>
//     </MDTypography>
//     {/* <MDInputRoot {...rest} ref={ref} ownerState={{ error, success, disabled }} fullWidth /> */}
//     {console.log(rest.error, "error")}
//     {/* <TextField {...rest} ref={ref} fullWidth /> */}
//     <TextField
//       {...rest}
//       // name="txtGroup"
//       // error={formik.errors.txtGroup}
//       fullWidth
//       // label="Email"
//       // onChange={formik.handleChange("txtGroup")}
//       helperText={rest.helperText}
//       sx={{
//         mb: { xs: 1.5, sm: 2 },
//         "& .MuiOutlinedInput-root": {
//           height: { xs: 48, sm: 56 },
//           backgroundColor: "white",
//           fontSize: { xs: "0.9rem", sm: "1rem" },
//           "&:hover .MuiOutlinedInput-notchedOutline": {
//             borderColor: "#1976d2",
//           },
//           "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//             borderColor: "#1976d2",
//           },
//         },
//       }}
//     />
//   </>
// ));

const MDInput = ({ error, success, disabled, ...rest }) => {
  return (
    <>
      <MDTypography style={{ fontSize: "16px", textTransform: "capitalize" }} color="dark">
        {rest.placeholder} <span style={{ color: "red" }}>{rest.required ? "*" : ""}</span>
      </MDTypography>
      {/* <MDInputRoot {...rest} ref={ref} ownerState={{ error, success, disabled }} fullWidth /> */}
      {console.log(rest.error, "error")}
      {/* <TextField {...rest} ref={ref} fullWidth /> */}
      <TextField
        {...rest}
        fullWidth
        helperText={rest.helperText}
        sx={{
          mb: { xs: 1.5, sm: 2 },
          "& .MuiOutlinedInput-root": {
            height: { xs: 48, sm: 56 },
            backgroundColor: "white",
            fontSize: { xs: "0.9rem", sm: "1rem" },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#1976d2",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#1976d2",
            },
          },
        }}
      />
    </>
  );
};

// Setting default values for the props of MDInput
MDInput.defaultProps = {
  error: false,
  success: false,
  disabled: false,
};

// Typechecking props for the MDInput
MDInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default MDInput;
